module.exports = __webpack_public_path__ + "static/media/low_click.c58eba39.wav";